import Vue from 'vue'
import Meta from 'vue-meta'

Vue.use(Meta)

export default {}



// WEBPACK FOOTER //
// ./src/initializers/vue-meta.js